import { render, staticRenderFns, recyclableRender, components } from "./cu-custom.vue?vue&type=template&id=7f57ace4&"
var renderjs
import script from "./cu-custom.vue?vue&type=script&lang=js&"
export * from "./cu-custom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\软件\\HBuilderX.2.3.3.20190923.full\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f57ace4')) {
      api.createRecord('7f57ace4', component.options)
    } else {
      api.reload('7f57ace4', component.options)
    }
    module.hot.accept("./cu-custom.vue?vue&type=template&id=7f57ace4&", function () {
      api.rerender('7f57ace4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "E:/uni_app/douyin/douyin/colorui/components/cu-custom.vue"
export default component.exports